import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/career_paths.json";

export const useCareerPaths = () => useSourceFlowCollection(data);

export default useCareerPaths;
